import {useRef, useLayoutEffect} from 'react'
import {useResizeObserver} from 'quickstart/hooks'
import {logger} from 'tizra'

const log = logger('quickstart/components/content/VideoPlayer')

export const VideoPlayer = ({oEmbed: {html}}) => {
  const [entry, callbackRef] = useResizeObserver()

  const wrapperWidth = entry?.contentRect?.width
  const wrapper = entry?.target

  // If the oEmbed provider doesn't supply their own responsiveness, then handle
  // it here. We use the sole iframe as a heuristic, since a responsive provider
  // will wrap the iframe in a div and/or supply a script alongside.
  const iframe =
    wrapper &&
    wrapper.children.length === 1 &&
    wrapper.children[0].tagName === 'IFRAME'
      ? wrapper.children[0]
      : null

  // We'll overwrite the width/height attributes on the iframe, so prepare to
  // stash the originals.
  const originalDimensions = useRef()

  useLayoutEffect(() => {
    if (iframe && wrapperWidth) {
      const {width, height} = (originalDimensions.current =
        originalDimensions.current || {
          width: iframe.getAttribute('width'),
          height: iframe.getAttribute('height'),
        })
      const ratio = width / height
      if (!ratio) {
        log.warn("iframe does not supply width/height, can't auto-resize")
        return
      }
      const calculatedHeight = Math.ceil(wrapperWidth / ratio)
      log.log(
        'updating iframe geometry from %sx%s to %sx%s',
        width,
        height,
        wrapperWidth,
        calculatedHeight,
      )
      iframe.setAttribute('width', wrapperWidth)
      iframe.setAttribute('height', calculatedHeight)
    }
  }, [iframe, wrapperWidth])

  return <div dangerouslySetInnerHTML={{__html: html}} ref={callbackRef} />
}
